import { Component, OnInit } from '@angular/core';
import {  PatientService, UserService } from '../shared';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-appstore',
  templateUrl: './appstore.component.html',
  styleUrls: ['./appstore.component.css']
})
export class AppstoreComponent implements OnInit {

  constructor(public patientservice: PatientService,private userService: UserService, private translate: TranslateService) {     
    this.translate.setDefaultLang(userService.defaultLang); 
  }
  us_Patient:boolean;
  ngOnInit() {
    this.us_Patient = this.patientservice.us_Patient
  }
  getFullYear(){
    return new Date().getFullYear();
  }
  setapp(){
    setTimeout(function () { location.href = "https://apps.apple.com/us/app/rc-coach/id1475273242"; }, 1000);
            location.href  = "RC-COACH://";
  }
  setappplaystore(){
    setTimeout(function () { location.href = "https://play.google.com/store/apps/details?id=com.ind.solvedge.recoverycoach"; }, 1000);
           // location.href  = "RC-COACH://";
  }

}
